import PropTypes from 'prop-types';
import React from 'react';

const SurveyBanner = ({ attachments, surveyId }) => {
  const attachment = attachments.filter(
    att => att.attachable_id === surveyId
  )[0];
  return attachment && attachment.banner_1000_url ? (
    <div className="ta-c" id={`srv-${surveyId}-bnr`}>
      <img src={attachment.banner_1000_url} className="mxw-100" />
    </div>
  ) : null;
};

SurveyBanner.propTypes = {
  attachments: PropTypes.array,
  surveyId: PropTypes.string.isRequired,
};

export default SurveyBanner;
